import { Grid, Tooltip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import IconPen from "app/common/Icon/IconPen";
import { ALL_SERVICES_TAB } from "app/common/LocalConst";
import {
  formatMoney,
  getDateTime,
  isAdmin,
  isRoleBranchManager,
  isRoleCashier,
  isRoleHisReadOnly,
  isSalesConsultant,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import RegisterServicePopup from "../RegisterServiceTreatmentPlanTab/Popup/RegisterServicePopup";
const ListServiceBlock = ({
  initialPatient,
  setCurrentTab,
  handleAfterSubmit,
}) => {
  const {
    openCreateOrEditServicePopup,
    handleOpenCreateOrEditServicePopup,
    handleCloseCreateOrEditServicePopup,
    saveOrUpdateRegisterService,
    initRegisterService,
    resetPopupStore,
  } = useStore().patientManagementStore.registerServiceStore;
  const { listVatPercent } =
    useStore().patientManagementStore.patientGeneralStore;
  const { t } = useTranslation();
  const isBranchManager = isRoleBranchManager();
  const isRoleSalesConsultant = isSalesConsultant();
  const isCashier = isRoleCashier();
  const isReadonly = isRoleHisReadOnly();
  const isAdminRole = isAdmin();
  const location = useLocation();
  const isInDetailPage =
    location.pathname === "/treatment-management/treatment-patient-info-detail";

  //
  const isEdit =
    ((isAdminRole || isBranchManager || isCashier || isRoleSalesConsultant) &&
      !isInDetailPage) ||
    (isInDetailPage && isAdminRole);

  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid
        container
        spacing={1}
        className="m-0 w-100"
        style={{ backgroundColor: "aliceblue" }}
      >
        <Grid item xs={12} className="search-title-card">
          <p className="title-block">Dịch vụ gần đây</p>
          <div className="flex align-center flex-end gap-1 cursor">
            {!isInDetailPage && (
              <p
                className="button-more"
                onClick={() => setCurrentTab(ALL_SERVICES_TAB)}
              >
                Xem thêm
              </p>
            )}
          </div>
        </Grid>

        <Grid item xs={12}>
          {(initialPatient?.patientServiceRegisterList || []).length > 0 ? (
            (initialPatient?.patientServiceRegisterList || []).map(
              (row, index) => (
                <>
                  <Grid
                    key={index}
                    item
                    xs={12}
                    style={{
                      borderBottom: "1px solid gray",
                      padding: "5px",
                      fontSize: "var(--fs-base)",
                    }}
                  >
                    <div className="medical-container">
                      <div className="text-medical-container">
                        <div>
                          <span className="text-medical">
                            {getDateTime(row?.orderDate)}
                          </span>
                        </div>
                        <div className="flex flex-wrap items-center">
                          <span className="name-medical">
                            {row?.service?.name}({formatMoney(row?.price)})
                          </span>

                          <span className="mx-2 text-gray-400">|</span>
                          <div className="flex justify-center items-center">
                            <span>Số lượng:</span>
                            <CloseIcon fontSize="inherit" />
                            <span className="value-medical">
                              {row?.quantity}
                            </span>
                          </div>
                        </div>
                      </div>
                      {isEdit && (
                        <div className="flex justify-center items-center p-2">
                          <Tooltip title="Chỉnh sửa">
                            <div
                              onClick={() => {
                                handleOpenCreateOrEditServicePopup(row);
                              }}
                            >
                              <IconPen />
                            </div>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                    <div className="flex mt-2">
                      <div>
                        Điều trị: <b>{row.totalPerformedTimes}</b> /{" "}
                        <b style={{ color: "red" }}>
                          {row.totalTreatmentTimes}
                        </b>
                      </div>
                      <span className="mx-2 text-gray-400">|</span>
                      <div>
                        Đã thu:{" "}
                        <b style={{ color: "green" }}>
                          {formatMoney(row?.totalBillPatientPaid || 0)}
                        </b>
                      </div>
                      <span className="mx-2 text-gray-400">|</span>
                      <div>
                        Cần thu:{" "}
                        <b style={{ color: "red" }}>
                          {formatMoney(row.amountActuallyPaid || 0)}
                        </b>
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: "var(--fs-base-two)",
                        color: "#374151",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        marginTop: "10px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "var(--fs-base-two)",
                          color: "black",
                          fontWeight: "bold",
                          marginBottom: "4px",
                        }}
                      >
                        Ghi chú:
                      </span>{" "}
                      {row?.note || "Không có ghi chú"}
                    </div>
                  </Grid>
                </>
              )
            )
          ) : (
            <div className="flex justify-center items-center w-full mt-5">
              Chưa có dữ liệu
            </div>
          )}
        </Grid>
        {!!openCreateOrEditServicePopup && (
          <RegisterServicePopup
            open={!!openCreateOrEditServicePopup}
            handleClose={handleCloseCreateOrEditServicePopup}
            onSubmit={saveOrUpdateRegisterService}
            initRegisterService={{
              ...initRegisterService,
              patientId: initialPatient?.patientInfo?.id,
            }}
            resetPopupStore={resetPopupStore}
            handleAfterSubmit={handleAfterSubmit}
            listVatPercent={listVatPercent}
          />
        )}
      </Grid>
    </div>
  );
};

export default memo(observer(ListServiceBlock));
